import HomeRoutes from './home';
import AllRoutes from './all';

const allRoutes = [];

export default allRoutes.concat(HomeRoutes, AllRoutes);
